module.exports = __webpack_public_path__ + "fonts/ABCGintoVCA-Bold.f8170dd2.otf";